import { SELECTORS } from '$utils/constants';

export const handleAgeSelect = (maxAgeSelector: string, minAgeSelector: string) => {
  const from = document.querySelector(maxAgeSelector) as HTMLSelectElement;
  const to = document.querySelector(minAgeSelector) as HTMLSelectElement;
  const handleFromSelect = () => {
    const fromValue = parseInt(from.value);

    // remove all options elements

    const allOptions = Array.from(to.options);
    for (const eachToOption of allOptions) {
      eachToOption.remove();
    }

    // add options elements
    const numberOfOptions = (100 - fromValue) / 10 - 1;
    // adding default option

    const defaultOption = document.createElement('option');
    defaultOption.value = 'default';
    defaultOption.textContent = 'To';
    to.appendChild(defaultOption);

    for (let i = numberOfOptions; i >= 0; i--) {
      const option = document.createElement('option');
      option.value = `${100 - i * 10}`;
      option.textContent = `${100 - i * 10}`;
      to.appendChild(option);
    }
  };

  from.addEventListener('change', handleFromSelect);
};
